<template>
  <div>
    <div style="" class="short_search_container">
      <div v-if="!shortSearch">Type 3 characters to start search</div>
      <el-checkbox :value="shortSearch" @change="toggleShortPlatesSearch">Search short plates</el-checkbox>
    </div>
    <div class="mass-edit-wrapper">
      <switch-checkbox :text="$t('common.mass-edit')" :onChange="toggleMassEdit" :checked="isMassEdit" />
    </div>
    <list-widget :items="parkings.items" routeName="parking" :hideHeader="true" :changeRoute="true"
      :addNewTitle="$t('top_bar.add_new_parking')" addNewRouteName="add-parking">
      <template slot="item-template" slot-scope="props">
        <ListItemTemplate :item="props.item" :isMassEdit="isMassEdit" :onClickCheckbox="addToCheckedList"
          :checked="isFindOnCheckedList(props.item.id)"></ListItemTemplate>
      </template>
    </list-widget>
    <div class="list-widget__footer items-container__footer" v-if="parkings.items">
      <slot name="footer">
        <a class="link" v-on:click.stop.prevent="extendLimit()" v-if="parkings.total > parkings.items.length">{{
          $t('common.load_more') }}</a>

        <div class="footer-actions" v-if="checkedList.length">
          <div class="footer-actions__selected">{{ $t('common.selected') }}: {{ checkedList.length }}</div>
          <div class="footer-actions__actions">
            {{ $t('common.actions') }}:
            <button type="button" class="btn btn--main btn--small" @click="showDeletingModal">{{ $t('common.delete')
            }}</button>
            <button type="button" class="btn btn--small" @click="toggleMassEdit(false)">{{ $t('common.discard')
            }}</button>
          </div>
        </div>
      </slot>
    </div>

    <ConfirmationModal v-if="showDeleteConfirmationModal" @cancel="hideDeletingModal" @confirmed="bulkDelete">
      <h1 slot="header">{{ $t('common.deleting') }}: {{ checkedList.length }}</h1>
      <p slot="body">{{ $t('parking.confirm_price_delete') }}</p>
    </ConfirmationModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';
import ListWidget from 'common/ListWidget';
import ListItemTemplate from 'parkings/ListItemTemplate';
import SwitchCheckbox from 'common/SwitchCheckbox';
import ConfirmationModal from 'common/ConfirmationModal';

export default {
  components: {
    ListWidget,
    ListItemTemplate,
    SwitchCheckbox,
    ConfirmationModal,
  },
  computed: mapGetters({
    parkings: 'landlord/parkings/parkings',
    parkingsLimit: 'landlord/parkings/limit',
    user: 'user/user/user',
    shortSearch: 'landlord/parkings/shortSearch',
  }),
  created() {
    this.$store.commit(`landlord/parkings/${mTypes.SET_LIMIT}`, 10);
    this.fetchParkings();
  },
  methods: {
    fetchParkings() {
      this.$store.dispatch('landlord/parkings/fetch', { keyword: this.$route.query.keyword, user: this.user, limit: this.parkingsLimit })
        .then(() => {
          if (this.parkings.total === 0) {
            this.$router.push({ name: 'add-parking' });
          }
        });
    },
    extendLimit() {
      this.$store.commit(`landlord/parkings/${mTypes.SET_LIMIT}`, this.parkingsLimit + 10);
    },
    toggleMassEdit(isChecked) {
      this.isMassEdit = isChecked;

      if (!isChecked) {
        this.clearCheckedList();
      }
    },
    toggleShortPlatesSearch() {
      this.$store.dispatch('landlord/parkings/toggleShortPlatesSearch');
    },
    clearCheckedList() {
      this.checkedList = [];
    },
    addToCheckedList(id, isChecked) {
      if (isChecked) {
        const findItem = this.checkedList.find(item => item === id);

        if (!findItem) {
          this.checkedList = [
            ...this.checkedList,
            id,
          ];
        }
      } else {
        this.checkedList = this.checkedList.filter(item => item !== id);
      }
    },
    isFindOnCheckedList(id) {
      const findItem = this.checkedList.find(item => item === id);

      if (findItem) return true;

      return false;
    },
    showDeletingModal() {
      this.showDeleteConfirmationModal = true;
    },
    hideDeletingModal() {
      this.showDeleteConfirmationModal = false;
    },
    bulkDelete() {
      const checkedList = [...this.checkedList];
      this.hideDeletingModal();
      this.toggleMassEdit(false);

      this.$store.dispatch('parkings/parking/deleteBulk', { user: this.user, ids: checkedList })
        .then(() => {
          this.$store.commit(`landlord/parkings/${mTypes.REMOVE_DATAS}`, checkedList);
          this.$router.push({ name: 'parkings' });
        });
    },
  },
  data() {
    return {
      isMassEdit: false,
      checkedList: [],
      showDeleteConfirmationModal: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.short_search_container {
  display: none;
}

@media (min-width: 1116px) {
  .short_search_container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parkings/Sidebar.vue